import * as actions from './redux/actions';

import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const HeaderThemeTwo = ({ operator, t }) => {
	return (
		<div className="common-header-theme-two">
			<a href="/" className="top_image">
				<img
					src={operator.header_logo}
					alt="DIS"
					className="logoo"
					id="main-logo"
					style={{ width: '350px' }}
				/>
			</a>

			<style>
				.nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
				margin-top: 265px;
				{'}'}
				.common-header-theme-two .header_ul:hover {'{'}
				background-color:
				{operator && operator.color_codes && operator.color_codes.secondary_color
					? operator.color_codes.secondary_color
					: ''}
				;{'}'}
				.common-header-theme-two .header_ul:hover .sublinks{'{'}
				display: flex
				{'}'}
			</style>

			<div
				className="header_links"
				style={{
					backgroundColor:
						operator && operator.color_codes && operator.color_codes.primary_color
							? operator.color_codes.primary_color
							: null,
					color: 'white',
				}}
			>
				{operator.show_header_links && operator.header_links
					? operator.header_links.map((val, i) => {
						return (
							<a className="header_ul" href={Object.values(val)}>
								<ul className="header_link">
									<span style={{ color: 'white', fontSize: '16px' }}>{Object.keys(val)}</span>
								</ul>
								{i < operator.header_links.length - 1 ? <span className="line" /> : ''}

								{Object.keys(val) == 'Destinos' && (
									<ul className="sublinks">
										<li>sdfsdf</li>
										<li>sdfsdf</li>
										<li>sdfsdf</li>
										<li>sdfsdf</li>
										<li>sdfsdf</li>
									</ul>
								)}
							</a>
						);
					})
					: null}
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderThemeTwo);



// WEBPACK FOOTER //
// ./src/features/common/HeaderThemeTwo.js